const iframeResizeMessageType = "hawk:iframe-height";
const iframeResizeRequestType = "hawk:iframe-resize-request";
const minIframeHeight = 320;
const maxIframeHeight = 5000;

const getHeight = (iframeDocument) => {
  const {body, documentElement} = iframeDocument;

  return Math.max(
    body?.scrollHeight || 0,
    body?.offsetHeight || 0,
    documentElement?.clientHeight || 0,
    documentElement?.scrollHeight || 0,
    documentElement?.offsetHeight || 0
  );
};

const clampHeight = (height) => {
  return Math.min(maxIframeHeight, Math.max(minIframeHeight, Math.round(height)));
};

export const iframeResize = () => {
  const iframe = document.querySelector("#myIframe");

  if (!iframe) {
    return;
  }

  const iframeOrigin = iframe.dataset.iframeOrigin || new URL(iframe.src, window.location.href).origin;
  let resizeObserver = null;
  let hasMeasuredHeight = false;

  const applyHeight = (height) => {
    iframe.style.minHeight = "0";
    iframe.style.height = `${clampHeight(height)}px`;
    hasMeasuredHeight = true;
  };

  const measureSameOriginHeight = () => {
    try {
      const iframeDocument = iframe.contentWindow?.document;

      if (!iframeDocument) {
        return false;
      }

      applyHeight(getHeight(iframeDocument));

      return true;
    } catch (error) {
      return false;
    }
  };

  const observeSameOriginHeight = () => {
    if (typeof ResizeObserver === "undefined") {
      return false;
    }

    try {
      const iframeDocument = iframe.contentWindow?.document;
      const resizeTarget = iframeDocument?.documentElement;

      if (!resizeTarget) {
        return false;
      }

      resizeObserver?.disconnect();
      resizeObserver = new ResizeObserver(() => {
        measureSameOriginHeight();
      });
      resizeObserver.observe(resizeTarget);

      return true;
    } catch (error) {
      return false;
    }
  };

  const requestCrossOriginHeight = () => {
    iframe.contentWindow?.postMessage({type: iframeResizeRequestType}, iframeOrigin);
  };

  iframe.addEventListener("load", () => {
    if (measureSameOriginHeight()) {
      observeSameOriginHeight();
      return;
    }

    requestCrossOriginHeight();
  });

  window.addEventListener("resize", () => {
    if (measureSameOriginHeight()) {
      return;
    }

    if (!hasMeasuredHeight) {
      iframe.style.height = `${Math.max(window.innerHeight, minIframeHeight)}px`;
    }

    requestCrossOriginHeight();
  });

  // Cross-origin iframes can only report their content height through postMessage.
  window.addEventListener("message", (event) => {
    if (event.origin !== iframeOrigin) {
      return;
    }

    if (typeof event.data !== "object" || event.data === null) {
      return;
    }

    if (event.data.type !== iframeResizeMessageType) {
      return;
    }

    if (typeof event.data.height !== "number" || Number.isNaN(event.data.height)) {
      return;
    }

    applyHeight(event.data.height);
  });
};
